import React from "react";
import { StaticImage } from "gatsby-plugin-image";

import "../index.css";

import LottiePlayer from "../../LottiePlayer";
import LogisticsProvider from "../../../../static/lottie/05-2-Logistics-Provider.json";
import CalculatePriceManually from "../../../../static/lottie/05-4-Calculate-Price-Manually.json";

type CardPropsType = {
  children?: React.ReactNode;
};

const cardDetails = [
  {
    text1: "On Demand Delivery",
    text2: "จัดส่งสินค้าได้ทันที",
    content: (
      <StaticImage
        className="absolute bottom-0"
        alt="On Demand Delivery"
        src={"../../../../static/image/on-demand-delivery.png"}
        height={350.17}
        width={360}
        placeholder="blurred"
      />
    ),
  },
  {
    text1: "Logistics Provider",
    text2: "บริการขนส่งชั้นนำ",
    content: (
      <LottiePlayer
        file={LogisticsProvider}
        height={"auto"}
        width={"100%"}
        lottieClassName="pb-10"
      />
    ),
  },
  {
    text1: "Cash on Delivery",
    text2: "ระบบเก็บเงินปลายทาง",
    content: (
      <StaticImage
        className="absolute bottom-0"
        alt="Cash on Delivery"
        src={"../../../../static/image/COD.png"}
        height={350.17}
        width={360}
        placeholder="blurred"
      />
    ),
  },
  {
    text1: "Calculate Price Manually",
    text2: "ระบบคิดค่าส่งตามน้ำหนัก",
    content: (
      <LottiePlayer
        file={CalculatePriceManually}
        height={"auto"}
        width={"100%"}
        lottieClassName="pb-10"
      />
    ),
  },
];

const CardScrollerShipping: React.FC<CardPropsType> = () => {
  return (
    <div className="relative">
      <div className="card-scroller-container p-6">
        <div>
          <h2 className="cards-shelf-main-header dashboard-heading-2">
            ทางเลือกการขนส่ง&nbsp;
          </h2>
          <span className="cards-shelf-secondary-header dashboard-heading-2">
            ที่เหมาะกับธุรกิจของคุณ
          </span>
        </div>
      </div>
      <div className="dp-cards-scroller">
        <div className="dp-cards-scroller-crop">
          <div className="dp-cards-scroller-content">
            <div className="dp-cards-scroller-platter">
              {cardDetails.map((card) => {
                return (
                  <div className="dp-cards-scroller-item-view" key={card.text1}>
                    <div className="dp-card-width-360">
                      <div className="dp-card-content">
                        <div className="dp-card-img-full-wrapper mt-10">
                          <div className="mt-12 absolute bottom-0 w-full">
                            {card.content}
                          </div>
                        </div>
                        <div className="dp-card-content-info">
                          <h3 className="dp-card-content-eyebrow">
                            {card.text1}
                          </h3>
                          <div className="dp-card-content-header">
                            <a className="dp-card-content-header-link">
                              {card.text2}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardScrollerShipping;
